import { useMutation } from "@tanstack/react-query";
import { clsx } from "clsx";
import { FileSpreadsheet } from "lucide-react";
import { Button } from "./Button";

interface XlsxExportButtonProps {
  /** Button text, e.g. „Pobierz zamówienia (.xlsx)". */
  label: string;
  title?: string;
  /** Rows the file will cover — 0 disables the button. */
  count: number;
  /** Fetches the sheet and saves it in the browser (see utils/download). */
  download: () => Promise<void>;
  disabled?: boolean;
  className?: string;
}

/**
 * „Pobierz … (.xlsx)" on a list page. One look and one failure message for every
 * list export (Projekty ZE, Zapotrzebowania, Zamówienia, Protokoły POCK), so the
 * pages only decide WHAT gets exported — the currently filtered rows — not how.
 */
export function XlsxExportButton({
  label,
  title,
  count,
  download,
  disabled,
  className,
}: XlsxExportButtonProps) {
  const mutation = useMutation({ mutationFn: download });
  return (
    <span className={clsx("inline-flex items-center gap-2", className)}>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        title={title}
        onClick={() => mutation.mutate()}
        disabled={disabled || count === 0 || mutation.isPending}
        loading={mutation.isPending}
      >
        <FileSpreadsheet size={13} /> {label}
      </Button>
      {mutation.isError && (
        <span className="text-xs text-[var(--color-primary)]">
          Nie udało się pobrać pliku. Spróbuj ponownie.
        </span>
      )}
    </span>
  );
}
